<label for="feature_{{feature.id}}">
  {{ feature.header }}<span *ngIf="feature.unitHeader">, {{ feature.unitHeader }}</span>
  <span *ngIf="isRequired()"> *</span>
  <span *ngIf="feature.comment" nbTooltip="{{feature.comment}}"><nb-icon icon="bulb-outline"></nb-icon></span>
</label>

<div class="accordion-item__right">
  <div class="accordion-item__select accordion-item__select-custom">
    <form [formGroup]="form">
      <ng-select [items]="featureValues$ | async"
                 [multiple]="isMultiple()"
                 [closeOnSelect]="!isMultiple()"
                 [hideSelected]="true"
                 [loading]="loading"
                 #select
                 (blur)="onBlur($event)"
                 formControlName="featureValue"
                 id="feature_{{feature.id}}"
                 placeholder="Классификатор"
                 i18n-placeholder="@@TemplateClassifierLabel"
                 appendTo="body"
                 bindLabel="value"
                 bindValue="id">
        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
          <div class="ng-value" *ngFor="let item of items | slice:0:showItemsCount">
            <span class="ng-value-label">{{ item.value }}</span>
            <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
          </div>
          <div class="ng-value" *ngIf="showAllSelectedValuesButton(items.length)">
            <span class="ng-value-icon" aria-hidden="true" (click)="showAllSelectedValues(select)">Еще {{ getHiddenSelectedItemsCount(items.length) }} значений...</span>
          </div>
          <div class="ng-value" *ngIf="showHideButton(items.length)">
            <span class="ng-value-icon" aria-hidden="true" (click)="hideExtraSelectedValues()" i18n="@@HideExtraSelectedValuesButton">Скрыть значения</span>
          </div>
        </ng-template>
      </ng-select>

      <div *ngIf="isMultiple() && featureValue.invalid && (featureValue.dirty || featureValue.touched)">
        <div *ngIf="featureValue.hasError('required')" class="text-danger" i18n="@@FeatureValueRequiredError">
          Поле обязательно для заполнения
        </div>
        <div *ngIf="featureValue.hasError('minlength')" class="text-danger" i18n="@@FeatureValueMinLengthError">
          Минимум {{ featureValue.errors.minlength.requiredLength }} значений
        </div>
        <div *ngIf="featureValue.hasError('maxlength')" class="text-danger" i18n="@@FeatureValueMaxLengthError">
          Превышен лимит выбранных значений: {{ featureValue.errors.maxlength.actualLength }} из {{ featureValue.errors.maxlength.requiredLength }}
        </div>
      </div>
    </form>
  </div>
  <div class="accordion-item__right-info">
    <div class="state-warn" *ngIf="featureValue.valid && isShowEmptyWarning()">
      <nb-icon icon="alert-triangle-outline"/>
    </div>
    <div class="state-err" *ngIf="featureValue.invalid">
      <nb-icon icon="alert-circle-outline"/>
    </div>
    <div class="state-success" *ngIf="featureValue.valid && !isEmpty()">
      <nb-icon icon="checkmark-outline"/>
    </div>

    <a [routerLink]="['/cabinet/pim/feature/edit/', feature.featureId]"
       class="entityID"
       target="_blank"
       i18n-nbTooltip="@@OpenFeatureInNewWindow"
       nbTooltip="Открыть характеристику в новом окне"
       *ngIf="featureLink">
      #{{ feature.featureId }}
    </a>
  </div>
</div>
